import React from 'react';
import { CHECKOUT_URL } from '../data/content';
export function SiteFooter() {
  return <footer className="bg-carbon-950 pb-28 pt-14 sm:pb-16" data-id="element-117" data-mp="3r7punplj411c">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-118" data-mp="3racd4k9yk0yc">
        <div className="flex flex-col gap-6 border-t border-carbon-800 pt-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-119" data-mp="3mgrfwug6vb07">
          <div data-id="element-120" data-mp="3hhwtlij0j4bc">
            <p className="text-sm font-bold tracking-tight text-white" data-id="element-121" data-mp="3hgddbrxcwt9k">
              La Biblia de las Fallas Típicas
            </p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-122" data-mp="38i1i1cljp7as">
              Guía digital de diagnóstico para técnicos en electrónica.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-slate-500" data-id="element-123" data-mp="33krhb0sph97n">
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-white" data-id="element-124" data-mp="2yleugg1u4252">
              Checkout seguro Hotmart
            </a>
            <span data-id="element-125" data-mp="15qc16e97tffy">© {new Date().getFullYear()} Todos los derechos reservados.</span>
          </div>
        </div>
      </div>
    </footer>;
}